export const FONTS = {
  bold: "HelveticaNeueLTPro-Bd",
  boldItalic: "HelveticaNeueLTPro-BdIt",
  light: "HelveticaNeueLTPro-Lt",
  lightItalic: "HelveticaNeueLTPro-LtIt",
  ultraLight: "HelveticaNeueLTPro-UltLt",
  thin: "HelveticaNeueLTPro-Th",
  normal: "HelveticaNeueLTPro-Roman",
};
